export const ACCOUNT_TRACK_ORDER = 'ACCOUNT_TRACK_ORDER';
export const ACCOUNT_TRACK_ORDER_SUCCESS = 'ACCOUNT_TRACK_ORDER_SUCCESS';
export const ACCOUNT_TRACK_ORDER_ERROR = 'ACCOUNT_TRACK_ORDER_ERROR';
export const GET_ORDER_DETAIL_LOADING_STOP = 'GET_ORDER_DETAIL_LOADING_STOP';
export const ACCOUNT_TRACK_ORDER_ONLOAD = 'ACCOUNT_TRACK_ORDER_ONLOAD';
export const ACCOUNT_TRACK_ORDER_LOADING_STOP = 'ACCOUNT_TRACK_ORDER_LOADING_STOP';
